import React, { useState } from "react";

const API_BASE = "http://localhost:3001";

export default function IfceHorseSearch() {
  const [name, setName] = useState("");
  const [candidates, setCandidates] = useState([]);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const canSearch = name.trim().length > 0;

  async function searchCandidates() {
    if (!canSearch) return;
    setLoading(true);
    setError("");
    setResult(null);
    setCandidates([]);

    try {
      const res = await fetch(`${API_BASE}/api/search-horse-candidates?name=${encodeURIComponent(name.trim())}`);
      const json = await res.json();
      if (!json.ok) throw new Error(json.error || "Erreur inconnue");

      if (json.directHit) {
        await fetchDetailsByName(json.title || name.trim());
        return;
      }

      setCandidates(json.candidates || []);
      if ((json.candidates || []).length === 1) {
        await fetchDetailsByName(json.candidates[0].text);
      }
    } catch (e) {
      setError(e.message || String(e));
    } finally {
      setLoading(false);
    }
  }

  async function fetchDetailsByName(horseName) {
    try {
      setLoading(true);
      setError("");
      const res = await fetch(`${API_BASE}/api/search-horse`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: horseName }),
      });
      const json = await res.json();
      if (!json.ok) throw new Error(json.error || "Erreur inconnue");
      setResult(json.data);
    } catch (e) {
      setError(e.message || String(e));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Test IFCE – Recherche / Import</h2>
      <input
        type="text"
        value={name}
        placeholder="Nom du cheval"
        onChange={(e) => setName(e.target.value)}
      />
      <button disabled={!canSearch || loading} onClick={searchCandidates}>
        {loading ? "Chargement..." : "Rechercher"}
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {candidates.length > 1 && (
        <ul>
          {candidates.map((c, idx) => (
            <li key={idx}>
              {c.text} <button onClick={() => fetchDetailsByName(c.text)}>Ouvrir</button>
            </li>
          ))}
        </ul>
      )}

      {result && (
        <div style={{ marginTop: 20 }}>
          <h3>{result.title}</h3>
          <pre>{result.resume}</pre>
        </div>
      )}
    </div>
  );
}
